import { render, staticRenderFns } from "./MultiplyEntity.vue?vue&type=template&id=2dd71af4&"
import script from "./MultiplyEntity.vue?vue&type=script&lang=ts&"
export * from "./MultiplyEntity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports